<script setup lang="ts"></script>

<template>
  <div class="media-item-list">
    <slot></slot>
  </div>
</template>

<style scoped lang="scss">
.media-item-list {
  display: flex;
  flex-direction: column;
  gap: $spacer-3;

  @include media-breakpoint-down(md) {
    gap: $spacer-2;
  }
}
</style>
